import { useLazyQuery } from '@biletiniz/apollo';
import { GET_USER } from './gql';

export const useGetUser = apolloClient => {
    const [getUser, { data, error, loading }] = useLazyQuery(GET_USER, {
        client: apolloClient,
        fetchPolicy: `network-only`,
    });

    return {
        getUser,
        data: data?.getUser,
        error: error?.message,
        loading,
    };
};
